export interface ITipoTurno {
    etiqueta: string;
    valor: number;
}

export interface Turnos {
    id: number;
    employees_Id: number;
    nombre: string;
    descripcion: string;
    creacion: Date;
    inicio: string;
    fin: string;
    tipo: number;
    horas: string;
    diasALaSemana: string;
    diasDescanso: string;
    users_id: number;
    cadenaInicio: string;
    cadenaFin: string;
    listaDiasDescanso: string[];
}

export interface TurnosVariosEmpleados {
    employees_Ids: number[];
    nombre: string;
    descripcion: string;
    creacion: Date;
    inicio: string;
    fin: string;
    tipo: number;
    horas: string;
    diasALaSemana: string;
    diasDescanso: string;
    users_id: number;
    cadenaInicio: string;
    cadenaFin: string;
    listaDiasDescanso: string[];
}

export const TIPOS_TURNOS: ITipoTurno[] = [
    {
        etiqueta: "Fijo",
        valor: 1,
    },
    {
        etiqueta: "Diario",
        valor: 2,
    },
    {
        etiqueta: "Personalizado",
        valor: 3,
    },
];

export interface RangoFechasRegistro_DTO {
    inicio: string;
    fin: string;
}

export interface DiaConTrabajo {
  fecha: string;
  empleados: DatosMinimosEmpleado[];
  cadenaFecha: string;
}

export interface DatosMinimosEmpleado {
  employees_Id: number;
  nombre: string;
  color: EventColor;
  nombreTurno: string;
  horas: string;
}

export interface EventColor {
  primary: string;
  secondary: string;
}